// extracted by mini-css-extract-plugin
export var modalFooter = "_pw-0";